var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vertical-item text-center" }, [
    _c(
      "div",
      {
        staticClass: "title p-1 text-white text-uppercase",
        class: _vm.isHighlight ? "bg-primary" : "bg-secondary"
      },
      [_c("span", [_vm._v(_vm._s(_vm.label))])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "position-relative" },
      [
        _c("small-carousel", {
          attrs: {
            images: _vm.images,
            "show-indicators": false,
            height: "160px"
          }
        }),
        _vm._v(" "),
        _vm.isOffertaSpeciale
          ? _c("div", { staticClass: "circle-area" }, [
              _c("p", [_vm._v("Offerta Speciale")])
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content-area" }, [
      _c("div", [_c("p", [_vm._v(_vm._s(_vm.name))])]),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-3" }, [_vm._v(_vm._s(_vm.date))]),
      _vm._v(" "),
      _c("div", { staticClass: "row", staticStyle: { height: "50px" } }, [
        _c("div", { staticClass: "col-6" }, [
          _vm.nights
            ? _c("div", { staticClass: "notti text-left mb-2" }, [
                _c("p", [
                  _c("b", [_vm._v(_vm._s(this.nights))]),
                  _vm._v(" notti"),
                  _c("br"),
                  _c("b", [_vm._v(_vm._s(this.days))]),
                  _vm._v(" giorni\n                    ")
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.isAltreDate
          ? _c("div", { staticClass: "dates-info col-6 mb-2" }, [
              _vm.isAltreDate
                ? _c("div", { staticClass: "dates position-relative" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dates text-uppercase",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            _vm.showAltreDate = !_vm.showAltreDate
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        altre date disponibili\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showAltreDate
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "position-absolute p-1 border rounded bg-white",
                            staticStyle: {
                              "z-index": "10",
                              "min-width": "240px",
                              "max-height": "160px",
                              overflow: "auto",
                              right: "0"
                            },
                            on: {
                              mouseleave: function($event) {
                                _vm.showAltreDate = false
                              },
                              click: function($event) {
                                _vm.showAltreDate = false
                              }
                            }
                          },
                          _vm._l(_vm.departureFutureDates, function(
                            item,
                            index
                          ) {
                            return _c(
                              "button",
                              {
                                key: index,
                                staticClass:
                                  "rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap",
                                staticStyle: { width: "45px" },
                                on: {
                                  click: function($event) {
                                    return _vm.onOpenDetailWithDate(item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.formatDate(item)))]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isPartenzaGarantita
          ? _c("div", { staticClass: "col-6 mb-2" }, [_vm._m(0)])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "price" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", [
          _c("h1", { staticClass: "currency mb-0" }, [
            _vm._v(_vm._s(_vm.price) + " €")
          ]),
          _vm._v(" "),
          _c("h5", { staticClass: "w-100 text-center text-uppercase mb-1" }, [
            _vm._v(_vm._s(_vm.isVoloRequested ? "volo incluso" : " "))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg px-5",
              on: { click: _vm.onOpenDetail }
            },
            [_vm._v("Scegli")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "partenza-garantita text-left" }, [
      _c("p", [_vm._v("partenza garantita")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("a partire da")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e892c94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e892c94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/mobile/widgets/common/tours/VerticalItemTour.vue
// module id = null
// module chunks = 